module.exports = __webpack_public_path__ + "img/yellow-luck-icon.9f2bbdad.svg";